import { getStoryHaystack } from "@/utils/newsroomCollections";

export const ENTITY_PAGE_CONFIG = {
  "houston-police-department": {
    key: "houston-police-department",
    route: "/houston-police-department",
    title: "Houston Police Department News",
    eyebrow: "Entity watch",
    description: "Track Houston Police Department news, officer-involved incidents, policy changes, investigations, and major HPD updates from Content Watch HQ.",
    heroCopy: "Built for entity SEO, this page groups HPD-related coverage into one permanent public search destination.",
    searchTargets: ["Houston Police Department news", "HPD updates", "Houston police investigation", "HPD officer involved shooting"],
    keywords: ["houston police", "hpd", "police chief", "police department", "officer involved"],
  },
  "harris-county-district-attorney": {
    key: "harris-county-district-attorney",
    route: "/harris-county-district-attorney",
    title: "Harris County District Attorney News",
    eyebrow: "Entity watch",
    description: "Follow Harris County District Attorney news, charging decisions, court developments, corruption probes, and accountability coverage from Content Watch HQ.",
    heroCopy: "This route gives search engines and readers a focused page for DA office developments and court-driven investigations.",
    searchTargets: ["Harris County DA news", "district attorney houston", "DA office updates", "Harris County charging decisions"],
    keywords: ["district attorney", "da office", "harris county da", "prosecutor", "charging decision"],
  },
  "houston-city-hall": {
    key: "houston-city-hall",
    route: "/houston-city-hall",
    title: "Houston City Hall News",
    eyebrow: "Entity watch",
    description: "Read Houston City Hall news, mayoral decisions, city council fights, policy debates, and local government accountability reporting.",
    heroCopy: "A permanent Houston City Hall page helps capture search demand around city council, the mayor, and major municipal decisions.",
    searchTargets: ["Houston City Hall news", "Houston mayor updates", "Houston city council news", "Houston municipal government"],
    keywords: ["city hall", "mayor", "city council", "controller", "municipal"],
  },
  "metro-houston": {
    key: "metro-houston",
    route: "/metro-houston",
    title: "METRO Houston News",
    eyebrow: "Entity watch",
    description: "Stay current on METRO Houston news, rail and bus disruptions, transit policy changes, safety issues, and rider-impacting updates.",
    heroCopy: "Transit riders and search engines now get a focused METRO Houston page for service, safety, and accountability coverage.",
    searchTargets: ["METRO Houston news", "Houston bus updates", "Houston rail issues", "METRO service disruption"],
    keywords: ["metro houston", "metro", "metrorail", "bus route", "transit"],
  },
  "houston-isd": {
    key: "houston-isd",
    route: "/houston-isd",
    title: "Houston ISD News",
    eyebrow: "Entity watch",
    description: "Track Houston ISD news, district leadership changes, school safety, campus disruptions, and education accountability coverage from Content Watch HQ.",
    heroCopy: "This education entity page creates a dedicated public route for HISD developments, leadership changes, and school-driven searches.",
    searchTargets: ["Houston ISD news", "HISD updates", "Houston school board news", "Houston education accountability"],
    keywords: ["houston isd", "hisd", "school board", "superintendent", "education"],
  },
};

export const ENTITY_PAGE_LIST = Object.values(ENTITY_PAGE_CONFIG);

export const getEntityStories = (feed, entityKey) => {
  const entity = ENTITY_PAGE_CONFIG[entityKey];
  if (!entity) {
    return [];
  }
  return (feed || []).filter((story) => entity.keywords.some((keyword) => getStoryHaystack(story).includes(keyword)));
};